module.exports = __webpack_public_path__ + "img/task.a21b713a.svg";